export enum LandingAnchors {
  HOME = "home",
  PLANS = "plans",
  HOW_IT_WORKS = "how-it-works",
}
